// The Operator Walk: shared constants for the sales page, client dashboard, and admin.
export const OW_API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// 20-point rubric mirrored from the backend (single source of truth for scoring lives server side).
export const RUBRIC = [
  {
    key: "product",
    title: "Product",
    points: [
      { id: 1, label: "Food quality at point of service (temperature, freshness, plating)" },
      { id: 2, label: "Recipe and portion execution" },
      { id: 3, label: "Product availability and presentation" },
      { id: 4, label: "Beverage execution" },
    ],
  },
  {
    key: "service",
    title: "Service",
    points: [
      { id: 5, label: "Speed of service at the observed daypart" },
      { id: 6, label: "Greeting, first impression, and guest engagement" },
      { id: 7, label: "Order accuracy" },
      { id: 8, label: "Staff knowledge and product training" },
    ],
  },
  {
    key: "image_venue",
    title: "Image and Venue",
    points: [
      { id: 9, label: "Exterior condition and curb appeal" },
      { id: 10, label: "Interior cleanliness, including dining room and restrooms" },
      { id: 11, label: "Staff appearance and uniform standards" },
      { id: 12, label: "Atmosphere (lighting, sound, temperature, scent)" },
    ],
  },
  {
    key: "pricing_value",
    title: "Pricing and Value",
    points: [
      { id: 13, label: "Menu clarity and pricing prominence" },
      { id: 14, label: "Price-to-quality alignment" },
      { id: 15, label: "Upsell and add-on execution" },
      { id: 16, label: "Value perception versus competitive set" },
    ],
  },
  {
    key: "operational_health",
    title: "Operational Health",
    points: [
      { id: 17, label: "Manager presence and floor engagement" },
      { id: 18, label: "Team cohesion and observable morale" },
      { id: 19, label: "Operational rhythm and control under load" },
      { id: 20, label: "Brand consistency and marketing execution" },
    ],
  },
];

export const CATEGORY_TITLE = RUBRIC.reduce((acc, c) => {
  acc[c.key] = c.title;
  return acc;
}, {});

export const FORMAT_TYPES = ["drive-thru", "walk-in", "full-service", "fast-casual", "other"];
export const CLIENT_STATUSES = ["active", "paused", "churned"];

export const SCORE_SCALE = [
  { value: 1, label: "Critical concern" },
  { value: 2, label: "Below expectations" },
  { value: 3, label: "Meeting expectations" },
  { value: 4, label: "Above expectations" },
  { value: 5, label: "Best in class" },
];

// Restrained, legible chart palette: deep purples plus two warm accents.
export const CATEGORY_COLORS = {
  product: "#3B1E5A",
  service: "#6B4AAF",
  image_venue: "#9377D9",
  pricing_value: "#C2410C",
  operational_health: "#0F766E",
};

// Score color for a 0-100 percentage. On brand, with a clear "needs attention" cue.
export function scoreColor(pct) {
  if (pct < 50) return "#B91C1C";
  if (pct < 65) return "#C2410C";
  if (pct < 80) return "#6B4AAF";
  return "#3B1E5A";
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
